import axios from "axios";
import { supabase } from "../supabaseClient";
import { addLeadLogs } from "./ChangeUnitRequest";

async function createPaymentOrder(obj) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_PAYMENT_LINK_URL + "payments/create-order-new",
        obj,
      )
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

async function getPreselectConfirmations(leadId) {
  const { data, error, count } = await supabase
    .from("AllotmentPayment")
    .select(
      "*, unitId(*,wingId(wingName,wingId,displayName), inventoryTypeId(*,type),projectId(*,projectName)), paymentId(*,eventId(title,preselectConfirmationConfig , eventId),eventTokenId(*,tokenId(amount))),inventoryMergedId(*, projectId(projectName),unit1Id(view,saleableArea,landOwnerName,floorNo, unitNo,unitOf,inventoryTypeId(*), wingId(*)),unit2Id(view,saleableArea,landOwnerName,floorNo, unitNo,inventoryTypeId(*), wingId(*))), AllotmentTransactions!inner(*))",
      { count: "exact" },
    )
    .eq("leadId", leadId)
    // .not('status', 'ilike', '%Cancel%')
    .eq("pricingType", "preselect")
    .not("status", "ilike", "%Refund%")
    .order("last_updated_at", { ascending: false });
  if (data) return { data, count };
  else throw error;
}

async function getPreselectConfirmationsConfig(
  eventId,
  eventTokenId,
  launchId,
) {
  const { data, error } = await supabase
    .from("PreselectConfirmationConfig")
    .select("*")
    .eq("eventId", eventId)
    .eq("eventTokenId", eventTokenId)
    .eq("launchId", launchId);
  if (data) return { data };
  else throw error;
}

async function getBookingAmountsByProjectId(
  projectId,
  inventoryTypeId,
  wingId,
) {
  const { data, error } = await supabase
    .from("BookingAmounts")
    .select("*")
    .eq("projectId", projectId)
    .eq("inventoryTypeId", inventoryTypeId)
    .eq("wingId", wingId);
  if (data) return { data };
  else throw error;
}
async function getPaymentPlansPriceFromServer(id, unitId) {
  let query = supabase
    .from("PaymentPlanPrice")
    .select("*", { count: "exact" })
    .eq("paymentPlanId", id)
    .eq("unitId", unitId);
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
// function submitPreselectConfirmation(
//   allotmentDetails,
//   updatedUnitCost,
//   bookingUnitCost,
//   isDiscountEligible,
// ) {
//   let leadStatus = "";
//   let unitStatus = "";
//   let allotmentStatus = "";
//   let bookingAmt = {
//     ocr: bookingUnitCost.OCR,
//     gst: bookingUnitCost.GST,
//     sdr: bookingUnitCost.SDR,
//     total: bookingUnitCost.TOTAL,
//   };
//   if (allotmentDetails.paidAmount < bookingUnitCost.TOTAL) {
//     leadStatus = "Allotment Partial Payment Done";
//     allotmentStatus = "Partial Payment Done";
//     unitStatus = "Payment Pending";
//   }

//   if (allotmentDetails.paidAmount >= bookingUnitCost.TOTAL) {
//     leadStatus = "Allotment Payment Complete";
//     allotmentStatus = "Payment Complete";
//     if (allotmentDetails.kycFormFilled === true) {
//       unitStatus = "Kyc Done";
//     } else {
//       unitStatus = "Kyc Pending";
//     }
//   }
//   return new Promise((resolve, reject) => {
//     supabase
//       .from("InventoryStatus")
//       .select("*")
//       .eq("status", unitStatus)
//       .then((inventoryStatus) => {
//         // ? submit confirmation for merged units
//         if (allotmentDetails.inventoryMergedId) {
//           supabase
//             .from("Inventory")
//             .update({
//               inventoryStatusId: inventoryStatus.data[0].inventoryStatusId,
//             })
//             .or(
//               "unitId.eq." + allotmentDetails.inventoryMergedId.unit1Id.unitId,
//               "unitId.eq." + allotmentDetails.inventoryMergedId.unit2Id.unitId,
//             )
//             .then(() => {
//               supabase
//                 .from("InventoryLogs")
//                 .insert({
//                   unitId: allotmentDetails.inventoryMergedId.unit1Id.unitId,
//                   leadId: allotmentDetails.leadId,
//                   userId: JSON.parse(localStorage.getItem("user")).userId
//                     .userId,
//                   status: unitStatus,
//                   pricingType: allotmentDetails.pricingType,
//                   eventId: allotmentDetails?.paymentId?.eventId.eventId,
//                   projectId:
//                     allotmentDetails.inventoryMergedId.unit1Id.projectId
//                       .projectId,
//                 })
//                 .then(() => {
//                   supabase
//                     .from("InventoryLogs")
//                     .insert({
//                       unitId: allotmentDetails.inventoryMergedId.unit2Id.unitId,
//                       leadId: allotmentDetails.leadId,
//                       userId: JSON.parse(localStorage.getItem("user")).userId
//                         .userId,
//                       status: unitStatus,
//                       pricingType: allotmentDetails.pricingType,
//                       eventId: allotmentDetails?.paymentId?.eventId.eventId,
//                       projectId:
//                         allotmentDetails.inventoryMergedId.unit2Id.projectId
//                           .projectId,
//                     })
//                     .then(() => {
//                       // supabase.from('AllotmentTransactions').insert({ paymentDetails: { transactionNumber: `${allotmentDetails.allotmentPaymentId}_${new Date().getTime()}`, ptrnNo: parseInt(ptrnNo) }, leadId: allotmentDetails.leadId, unitId: allotmentDetails.unitId.unitId, allotmentPaymentId: allotmentDetails.allotmentPaymentId, amount: parseFloat(amount), transactionType: 'Allotment', modeOfPayment: 'Razorpay-Customer Portal', status: "complete" }).then(async (_re) => {
//                       supabase
//                         .from("AllotmentPayment")
//                         .update({
//                           status: allotmentStatus,
//                           preselectConfirmation: "confirmed",
//                           isDiscountEligible: isDiscountEligible,
//                           unitCost: updatedUnitCost,
//                           last_updated_at: Date.now(),
//                           firstPaymentDate: Date.now(),
//                           bookingAmt: bookingAmt,
//                           preselectConfirmationDate: Date.now(),
//                         })
//                         .eq(
//                           "allotmentPaymentId",
//                           allotmentDetails.allotmentPaymentId,
//                         )
//                         .then(async (_resp) => {
//                           // supabase.from('AllotmentTransactions').update({ status: "complete" }).eq('paymentDetails->ptrnNo', ptrnNo).then(async (_re) => {
//                           // await supabase.from('LeadStatus').update({ status: ((payments.data[i].totalCost - allotmentDetails.paidAmount) > amount) ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete' }).eq('leadId', payments.data[0].leadId).then((_r) => {
//                           supabase
//                             .from("LeadStatus")
//                             .update({
//                               status: leadStatus,
//                               last_updated_at: Date.now(),
//                             })
//                             .eq("leadId", allotmentDetails.leadId)
//                             .then((_r) => {
//                               let obj = {
//                                 leadId: allotmentDetails.leadId,
//                                 leadStatus: leadStatus,
//                                 message: `Preselect confirmation done for Unit ${
//                                   allotmentDetails?.inventoryMergedId?.unit1Id
//                                     ?.unit1No
//                                     ? allotmentDetails?.inventoryMergedId
//                                         ?.unit1Id?.unit1No +
//                                       allotmentDetails?.inventoryMergedId
//                                         ?.unit12d?.unit2No
//                                     : allotmentDetails?.unitId?.unitNo
//                                 } of Wing - ${
//                                   allotmentDetails?.unitId?.wingId?.displayName
//                                     ? allotmentDetails?.unitId?.wingId
//                                         ?.displayName
//                                     : allotmentDetails?.unitId?.wingId?.wingName
//                                 } , ${allotmentDetails.unitId?.projectId?.projectName} for event ${
//                                   allotmentDetails?.paymentId?.eventId.title
//                                 }`,
//                               };
//                               addLeadLogs(obj)
//                                 .then((leadLog) => {
//                                   console.log(leadLog);
//                                 })
//                                 .catch((err) => {
//                                   console.log("leadlog", err);
//                                 });
//                               resolve({ success: true });
//                             })
//                             .catch((err) => {
//                               console.log("err: ", err);
//                               reject({ success: false });
//                             });
//                         })
//                         .catch((err) => {
//                           console.log("err: ", err);
//                           reject({ success: false });
//                         });
//                     })
//                     .catch((err) => {
//                       console.log("err: ", err);
//                       reject({ success: false });
//                     });
//                 })
//                 .catch((err) => {
//                   console.log("err: ", err);
//                   reject({ success: false });
//                 });
//             })
//             .catch((err) => {
//               console.log("err: ", err);
//               reject({ success: false });
//             });
//         } else {
//           // ? submit confirmation for single unit
//           supabase
//             .from("Inventory")
//             .update({
//               inventoryStatusId: inventoryStatus.data[0].inventoryStatusId,
//             })
//             .eq("unitId", allotmentDetails.unitId.unitId)
//             .then(() => {
//               supabase
//                 .from("InventoryLogs")
//                 .insert({
//                   unitId: allotmentDetails.unitId.unitId,
//                   leadId: allotmentDetails.leadId,
//                   userId: JSON.parse(localStorage.getItem("user")).userId
//                     .userId,
//                   status: unitStatus,
//                   pricingType: allotmentDetails.pricingType,
//                   eventId: allotmentDetails?.paymentId?.eventId.eventId,
//                   projectId: allotmentDetails.unitId.projectId.projectId,
//                 })
//                 .then(() => {});
//               supabase
//                 .from("AllotmentPayment")
//                 .update({
//                   status: allotmentStatus,
//                   preselectConfirmation: "confirmed",
//                   isDiscountEligible: isDiscountEligible,
//                   unitCost: updatedUnitCost,
//                   last_updated_at: Date.now(),
//                   firstPaymentDate: Date.now(),
//                   bookingAmt: bookingAmt,
//                   preselectConfirmationDate: Date.now(),
//                 })
//                 .eq("allotmentPaymentId", allotmentDetails.allotmentPaymentId)
//                 .then(async (_resp) => {
//                   // supabase.from('AllotmentPayment').update({ isDiscountApplied: true, preselectConfirmation: 'confirmed', last_updated_at: Date.now(), firstPaymentDate: Date.now(), unitCost: updatedUnitCost }).eq('allotmentPaymentId', allotmentDetails.allotmentPaymentId).then(async (_resp) => {
//                   // supabase.from('AllotmentTransactions').update({ status: "complete" }).eq('paymentDetails->ptrnNo', ptrnNo).then(async (_re) => {
//                   // await supabase.from('LeadStatus').update({ status: ((payments.data[i].totalCost - allotmentDetails.paidAmount) > amount) ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete' }).eq('leadId', payments.data[0].leadId).then((_r) => {
//                   supabase
//                     .from("LeadStatus")
//                     .update({ status: leadStatus, last_updated_at: Date.now() })
//                     .eq("leadId", allotmentDetails.leadId)
//                     .then((_r) => {
//                       resolve({ success: true });
//                       let obj = {
//                         leadId: allotmentDetails.leadId,
//                         leadStatus: leadStatus,
//                         message: `Preselect confirmation done for Unit ${
//                           allotmentDetails?.inventoryMergedId?.unit1Id?.unit1No
//                             ? allotmentDetails?.inventoryMergedId?.unit1Id
//                                 ?.unit1No +
//                               allotmentDetails?.inventoryMergedId?.unit12d
//                                 ?.unit2No
//                             : allotmentDetails?.unitId?.unitNo
//                         } of Wing - ${
//                           allotmentDetails?.unitId?.wingId?.displayName
//                             ? allotmentDetails?.unitId?.wingId?.displayName
//                             : allotmentDetails?.unitId?.wingId?.wingName
//                         } ,${allotmentDetails.unitId?.projectId?.projectName} for event ${
//                           allotmentDetails?.paymentId?.eventId.title
//                         }`,
//                       };
//                       addLeadLogs(obj)
//                         .then((leadLog) => {
//                           console.log(leadLog);
//                         })
//                         .catch((err) => {
//                           console.log("leadlog", err);
//                         });
//                     })
//                     .catch((err) => {
//                       console.log("err: ", err);
//                       reject({ success: false });
//                     });
//                 })
//                 .catch((err) => {
//                   console.log("err: ", err);
//                   reject({ success: false });
//                 });
//             })
//             .catch((err) => {
//               console.log("err: ", err);
//               reject({ success: false });
//             });
//         }
//       })
//       .catch((err) => {
//         console.log("err: ", err);
//         reject({ success: false });
//       });
//   });
// }
function submitPreselectConfirmation(
  allotmentDetails,
  updatedUnitCost,
  bookingUnitCost,
  isDiscountEligible,
  userId,
) {
  let leadStatus = "";
  let unitStatus = "";
  let allotmentStatus = "";
  let bookingAmt = {
    ocr: bookingUnitCost.OCR,
    gst: bookingUnitCost.GST,
    sdr: bookingUnitCost.SDR,
    total: bookingUnitCost.TOTAL,
  };
  if (allotmentDetails.paidAmount < bookingUnitCost.TOTAL) {
    leadStatus = "Allotment Partial Payment Done";
    allotmentStatus = "Partial Payment Done";
    unitStatus = "Payment Pending";
  }

  if (allotmentDetails.paidAmount >= bookingUnitCost.TOTAL) {
    leadStatus = "Allotment Payment Complete";
    allotmentStatus = "Payment Complete";
    if (allotmentDetails.kycFormFilled === true) {
      unitStatus = "Kyc Done";
    } else {
      unitStatus = "Kyc Pending";
    }
  }
  return new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_PAYMENT_LINK_URL +
          "preSelection/submitConfirmation",
        {
          allotmentDetails,
          updatedUnitCost,
          bookingUnitCost,
          isDiscountEligible,
          userId,
        },
      )
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function CancelPreselectConfirmation(allotmentDetails) {
  return new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_PAYMENT_LINK_URL + "units/cancelPreselect", {
        unitId: allotmentDetails.unitId?.unitId,
        eventId:
          allotmentDetails?.paymentId?.eventId?.eventId ||
          allotmentDetails?.paymentId?.eventId,
        launchId: allotmentDetails?.launchId,
        mode: "preselect2",
        paymentId: allotmentDetails?.paymentId?.paymentId,
      })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
async function getLeadAllotments(leadId) {
  const { data, error, count } = await supabase
    .from("AllotmentPayment")
    .select(
      "*,CRM!left(*,crmUserId(userId,roleId,name)),bookingFormId(*), unitId(*, inventoryStatusId(status),inventoryTypeId(type),projectId(projectName,customerDisplayInventoryType, addressLine1, addressLine2, city, state, country, Latitude, Longitude, bookingOcr, bookingSdr,bookingGst,bookingAmt , projectId), wingId(wingName , displayName)), paymentId(*, eventTokenId(*,tokenId(*,inventoryTypeId(*)), eventId(*))),inventoryMergedId(*, projectId(projectName,customerDisplayInventoryType),unit1Id(unitId,view,saleableArea,landOwnerName,floorNo, unitNo,inventoryTypeId(*), wingId(*)),unit2Id(unitId,view,saleableArea,landOwnerName,floorNo, unitNo,inventoryTypeId(*), wingId(*))),AllotmentTransactions!left(*) , CancelUnitRequests!left(*) ",
      { count: "exact" },
    )
    .eq("leadId", leadId)
    .or("pricingType.neq.preselect,preselectConfirmation.eq.confirmed")
    .order("last_updated_at", { ascending: false });
  if (data) return { data, count };
  else throw error;
}
async function getLeadAllotmentsForDashboard(leadId) {
  console.log("getLeadAllotmentsForDashboard leadId ====> ", leadId);
  const { data, error, count } = await supabase
    .from("AllotmentPayment")
    .select(
      "*,CRM!left(*,crmUserId(userId,roleId,name)),bookingFormId(*), unitId(*, inventoryStatusId(status),inventoryTypeId(*,type),projectId(*,projectName,customerDisplayInventoryType, addressLine1, addressLine2, city, state, country, Latitude, Longitude, bookingOcr, bookingSdr,bookingGst,bookingAmt,legalCharges), wingId(*,wingName , displayName)), paymentId(*, eventTokenId(*,tokenId(*,inventoryTypeId(*)), eventId(*))),inventoryMergedId(*, projectId(projectName,customerDisplayInventoryType),unit1Id(unitId,view,saleableArea,landOwnerName,floorNo, unitNo,inventoryTypeId(*), wingId(*), projectId(buId)),unit2Id(unitId,view,saleableArea,landOwnerName,floorNo, unitNo,inventoryTypeId(*), wingId(*))),AllotmentTransactions!left(*) , CancelUnitRequests!left(*),leadId(*,LeadsReferral!left(id))",
    )
    .eq("leadId", leadId)
    .order("last_updated_at", { ascending: false });
  console.log("data, count ====> ", data, count);
  if (data) return { data, count };
  else throw error;
}
function updateSdrPayment(allotmentDetails, amount, ptrnNo) {
  return new Promise((resolve, reject) => {
    supabase
      .from("AllotmentTransactions")
      .insert({
        paymentDetails: {
          transactionNumber: `${allotmentDetails.allotmentPaymentId}_${new Date().getTime()}`,
          ptrnNo: parseInt(ptrnNo),
        },
        payId: ptrnNo,
        leadId: allotmentDetails.leadId,
        unitId: allotmentDetails.inventoryMergedId
          ? allotmentDetails.inventoryMergedId.inventoryMergedId
          : allotmentDetails.unitId.unitId,
        allotmentPaymentId: allotmentDetails.allotmentPaymentId,
        amount: parseFloat(amount),
        transactionType: "Allotment",
        modeOfPayment: "Razorpay-Customer Portal",
        status: "complete",
      })
      .then(async (_re) => {
        supabase
          .from("AllotmentPayment")
          .update({
            paidAmount: parseFloat(allotmentDetails.paidAmount + amount),
            last_updated_at: Date.now(),
          })
          .eq("allotmentPaymentId", allotmentDetails.allotmentPaymentId)
          .then(async (_resp) => {
            // ! not updated lead status because what should be the next status?
            // !!Leadlogs to be added for Sdr partial payment
            let obj = {
              leadId: allotmentDetails.leadId,
              leadStatus: `SDR Partial Payment`,
              message: `Unit ${
                allotmentDetails?.inventoryMergedId?.unit1Id?.unit1No
                  ? allotmentDetails?.inventoryMergedId?.unit1Id?.unit1No +
                    allotmentDetails?.inventoryMergedId?.unit12d?.unit2No
                  : allotmentDetails?.unitId?.unitNo
              },Amount Paid:${parseFloat(allotmentDetails.paidAmount + amount)}`,
            };
            addLeadLogs(obj)
              .then((leadLog) => {
                console.log(leadLog);
              })
              .catch((err) => {
                console.log("leadlog", err);
              });
            // supabase.from('LeadStatus').update({ status: ((500000 - allotmentDetails.paidAmount) > amount) ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete' }).eq('leadId', allotmentDetails.leadId).then((_r) => {
            resolve({ success: true });
          })
          .catch((err) => {
            console.log("err: ", err);
            reject({ success: false });
          });
      })
      .catch((err) => {
        console.log("err: ", err);
        reject({ success: false });
      });
  });
}
async function sdrPaymentMode() {
  return new Promise((resolve, reject) => {
    supabase
      .from("Settings")
      .select("*")
      .eq("id", 1)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

async function getPaymentLinkMode(allotmentDetails, amount) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}payments/create-payment-link-new`,
        {
          mode: "allotment",
          amount: amount,
          leadName: JSON.parse(localStorage.getItem("selectedLead")).personId
            .name,
          leadEmail: JSON.parse(localStorage.getItem("selectedLead")).personId
            .email,
          leadContactNumber: JSON.parse(localStorage.getItem("selectedLead"))
            .personId.contactNumber,
          allotmentPaymentId: allotmentDetails?.allotmentPaymentId,
          unitId: allotmentDetails?.unitId?.unitId,
          inventoryMergeId:
            allotmentDetails?.inventoryMergedId?.inventoryMergeId,
          leadId: allotmentDetails?.leadId,
        },
      )
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

async function getPyamentLink(id) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}payments/get-payment-link`,
        { linkId: id },
      )
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

async function getpaymentPlanPriceDetailsFromUnitId(unitId) {
  const { data, error } = await supabase
    .from("PaymentPlanPrice")
    .select("*")
    .eq("unitId", unitId);
  if (data) return { data };
  else throw error;
}

async function getApplicantsForEmandate(allotmentPaymentId) {
  const { data, error } = await supabase
    .from("AgreementForm")
    .select("applicants")
    .eq("allotmentPaymentId", allotmentPaymentId)
    .single();

  console.log("AgreementForm response:", data);

  if (error) {
    console.error("Supabase error:", error);
    throw error;
  }

  return data;
}

async function getBookingIdFromAllotmentPaymentId(allotmentPaymentId) {
  console.log("getBookingIdFromAllotmentPaymentId ---->", allotmentPaymentId);

  const { data, error } = await supabase
    .from("AllotmentPayment")
    .select("bookingId")
    .eq("allotmentPaymentId", allotmentPaymentId)
    .single();

  console.log("AllotmentPayment response:", data);

  if (error) {
    console.error("Supabase error:", error);
    throw error;
  }

  const { data: agreementFormData, error: fetchformError } = await supabase
    .from("AgreementForm")
    .select("applicants")
    .eq("allotmentPaymentId", allotmentPaymentId);

  if (fetchformError && fetchformError.code !== "PGRST116") {
    console.error("Error for agreementFormData:", fetchformError);
    // Handle error without throwing; log the error for debugging
  }

  return { data: data, agreementFormData: agreementFormData };
}
// API for EMandate Bank Verification

async function getBankAccountVerificationStatusForEmandate(
  bankDetails,
  allotmentPaymentId,
  selectApplicantNameAsPerPan,
) {
  console.log(
    "inside getBankAccountVerificationStatusForEmandate api call --->",
    bankDetails,
    allotmentPaymentId,
    selectApplicantNameAsPerPan,
  );

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}emandate/verify-bank-details`,
        {
          bankAccountNumber: bankDetails.accountNumber,
          ifscCode: bankDetails.ifscCode,
          allotmentPaymentId: allotmentPaymentId,
          frontendNameAsPerPan: selectApplicantNameAsPerPan,
        },
      )
      .then((response) => {
        console.log(
          "Bank Account Verification Status Response from server --->",
          response,
        );
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

//Emandate Details APIs
async function getEmandateRecords(allotmentPaymentId) {
  console.log("inside getEmandateRecords query", allotmentPaymentId);

  const { data, error } = await supabase
    .from("EmandateDetails")
    .select("*")
    .in("allotmentPaymentId", allotmentPaymentId);

  if (error && error.code !== "PGRST116") {
    console.error("Error fetching eMandateDetails:", error);
    throw error;
  }
  console.log("EmandateDetails fetched data:", data);
  return data;
}

// insert multiple applicants record
async function insertEmandateDetailsRecord(applicants) {
  try {
    const insertResults = [];
    console.log("inserrt record applicant", applicants);

    for (const applicant of applicants) {
      const {
        allotmentPaymentId,
        consumerId,
        isSplit,
        splitRatio,
        emandateAmount,
      } = applicant;
      console.log("amount and ratio====>", splitRatio, emandateAmount);
      console.log("single applicant--->", applicant);

      // 🔍 STEP 1: Check if existing record exists for the same allotmentPaymentId and consumerId
      const { data: existingRecord, error: fetchError } = await supabase
        .from("EmandateDetails")
        .select("*")
        // .select("emandateId") // lightweight
        .eq("allotmentPaymentId", allotmentPaymentId)
        .eq("consumerId", consumerId);

      const exists = existingRecord.length > 0;
      console.log("exists====>", exists);

      console.log("existing -", existingRecord);

      if (fetchError && fetchError.code !== "PGRST116") {
        console.error("Error checking existing eMandateDetails:", fetchError);
        // Handle error without throwing; log the error for debugging
        continue; // Skip to the next applicant
      }

      // 🚫 STEP 2: Block insertion if an active mandate exists (for "Pending" or "Initiated")
      if (exists) {
        const { data: updatedData, error: updateError } = await supabase
          .from("EmandateDetails")
          .update({
            emandateStatus: "Pending", // Update status or other fields as needed
            splitRatio, // Update percentage
            emandateAmount, // Update amount
            name: applicant.name, // Update name
            isSplit, // Update isSplit based on the applicant data
            emiDebitDay:applicant.emiDebitDay
          })
          .eq("allotmentPaymentId", allotmentPaymentId)
          .eq("consumerId", consumerId);
        // .select("*");
        // .single();

        if (updateError) {
          console.error("Error updating eMandateDetails:", updateError);
          insertResults.push({
            action: "updated",
            isInserted: false,
            message: `Error updating eMandate details for consumerId: ${consumerId}.`,
          });
          continue; // Skip to the next applicant if update fails
        }

        insertResults.push({
          action: "updated",
          isInserted: true,
          message: `eMandate details for consumerId: ${consumerId} updated successfully.`,
          updatedData: updatedData,
        });
      } else {
        // 🚀 STEP 3: If no existing record, insert new record
        const { data, error: insertError } = await supabase
          .from("EmandateDetails")
          .insert([applicant]) // Insert the applicant's data into the database
          .select("*")
          .single(); // Insert one record at a time

        if (insertError) {
          console.error("Error inserting into eMandateDetails:", insertError);
          insertResults.push({
            isInserted: false,
            message: `Error inserting eMandate details for consumerId: ${consumerId}.`,
          });
          continue; // Skip to the next applicant if insertion fails
        }

        insertResults.push({
          action: "inserted",
          isInserted: true,
          message: `eMandate details for consumerId: ${consumerId} inserted successfully.`,
          insertedData: data,
        });
      }
    }

    return insertResults; // Return the result for each applicant
  } catch (err) {
    console.error("insertEmandateDetailsRecord failed:", err);
    throw err;
  }
}

// async function insertSingleEmandateDetailsRecord(applicant) {
//   try {
//     console.log("Insert single record applicant --->", applicant);

//     const {
//       allotmentPaymentId,
//       consumerId,
//       isSplit,
//       splitRatio,
//       emandateAmount,
//     } = applicant;

//     // STEP 1: Check if record already exists
//     const { data, error } = await supabase
//       .from("EmandateDetails")
//       .select("*")
//       .eq("allotmentPaymentId", allotmentPaymentId)
//       .eq("consumerId", consumerId);

//     if (error) {
//       console.error("Fetch error:", error);
//       return { isInserted: false, message: "Error checking record" };
//     }

//     const existingRecord = data.length > 0 ? data[0] : null;

//     // STEP 2: If record exists
//     if (existingRecord) {
//       console.log("Record already exists");

//       // If finalized → block
//       if (
//         existingRecord.splitRatio === 100 ||
//         existingRecord.emandateStatus === "Completed"
//       ) {
//         return {
//           isInserted: false,
//           message: `eMandate already finalized for consumerId: ${consumerId}`,
//         };
//       }

//       // Otherwise update
//       const { data: updatedData, error: updateError } = await supabase
//         .from("EmandateDetails")
//         .update({
//           emandateStatus: "Pending",
//           splitRatio,
//           emandateAmount,
//           isSplit,
//           name: applicant.name,
//         })
//         .eq("allotmentPaymentId", allotmentPaymentId)
//         .eq("consumerId", consumerId)
//         .select();
//       // .single();

//       if (updateError) {
//         console.error("Update error:", updateError);
//         return {
//           isInserted: false,
//           message: "Error updating record",
//         };
//       }

//       return {
//         isInserted: true,
//         action: "updated",
//         updatedData,
//         message: "Record updated successfully",
//       };
//     }

//     // STEP 3: If no existing record → insert
//     const { data: insertedData, error: insertError } = await supabase
//       .from("EmandateDetails")
//       .insert([applicant])
//       .select();
//     // .single();

//     if (insertError) {
//       console.error("Insert error:", insertError);
//       return {
//         isInserted: false,
//         message: "Error inserting record",
//       };
//     }

//     return {
//       isInserted: true,
//       action: "inserted",
//       insertedData,
//       message: "Record inserted successfully",
//     };
//   } catch (err) {
//     console.error("insertSingleEmandateDetailsRecord failed:", err);
//     return {
//       isInserted: false,
//       message: "Unexpected error occurred",
//     };
//   }
// }

async function updateEmandateRecords(allotmentPaymentId, obj) {
  console.log("Updating eMandateDetails for mandateId:", obj);
  console.log("inside supabase query", allotmentPaymentId);

  const { data, error } = await supabase
    .from("EmandateDetails")
    .update(obj)
    .eq("allotmentPaymentId", allotmentPaymentId)
    .eq("consumerId", obj.consumerId);

  if (error && error.code !== "PGRST116") {
    console.error("Error fetching eMandateDetails:", error);
    throw error;
  }

  return data;
}

async function fetchEMandateTransactionSummary(mandateData) {
  console.log(
    "Fetching eMandateTransactionSummary for mandateData:",
    mandateData,
  );

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}emandate/getTransanctionSummaryByMadateId`,
        {
          mandateId1: mandateData[0]?.mandateId,
        },
      )
      .then((response) => {
        console.log("get transaction response  --->", response);
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

async function getEmandatesfromLeadID(leadId) {
  console.log("getEmandatesfromLeadID leadId ====> ", leadId);

  // First, fetch the AllotmentPayment data based on leadId
  const {
    data: allotmentPayments,
    error: allotmentError,
    count,
  } = await supabase
    .from("AllotmentPayment")
    .select("allotmentPaymentId")
    .eq("leadId", leadId);

  if (allotmentError) {
    console.error("Error fetching AllotmentPayments:", allotmentError);
    throw allotmentError;
  }

  // Now, use the AllotmentPaymentIds to fetch CRM data
  const allotmentPaymentIds = allotmentPayments.map(
    (item) => item.allotmentPaymentId,
  );

  // Fetch corresponding isEligible status from CRM based on allotmentPaymentId
  const { data: crmData, error: crmError } = await supabase
    .from("CRM")
    .select("allotmentPaymentId, isEmandateEligible")
    .in("allotmentPaymentId", allotmentPaymentIds);

  if (crmError) {
    console.error("Error fetching CRM data:", crmError);
    throw crmError;
  }

  console.log("Allotment Payments:", allotmentPayments);
  console.log("CRM Data:", crmData);

  return { data: crmData, count };
}

async function fetchMandateHistoryByConsumerId(consumerId) {
  console.log("Fetching MandateHistory ByConsumerId :", consumerId);

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}emandate/emandate-history-records`,
        {
          consumerId: consumerId,
        },
      )
      .then((response) => {
        console.log("get emandate-history-records response  --->", response);
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export {
  getApplicantsForEmandate,
  getBookingAmountsByProjectId,
  getPreselectConfirmationsConfig,
  getLeadAllotments,
  getLeadAllotmentsForDashboard,
  getPreselectConfirmations,
  submitPreselectConfirmation,
  updateSdrPayment,
  createPaymentOrder,
  CancelPreselectConfirmation,
  sdrPaymentMode,
  getPaymentLinkMode,
  getPyamentLink,
  getPaymentPlansPriceFromServer,
  getpaymentPlanPriceDetailsFromUnitId,
  getBankAccountVerificationStatusForEmandate,
  insertEmandateDetailsRecord,
  updateEmandateRecords,
  fetchEMandateTransactionSummary,
  getEmandateRecords,
  getBookingIdFromAllotmentPaymentId,
  getEmandatesfromLeadID,
  fetchMandateHistoryByConsumerId,
  // insertSingleEmandateDetailsRecord,
};
